export default {
    GET_SELECT_DESIGNATED_MEMBER:(state)=>{
        return state.selectDesignatedMember
    },
    GET_RESULT:(state)=>{
        return state.Result
    },
    GET_EDIT_DESIGNATED_MEMBER:(state)=>{
        return state.editDesignatedMember
    },
}